import React from 'react'

const Search = () => {
  return (
    <div className='h-12'>
      <div className='bidjs-app container' id='bidjs__search' />
      <span className='sr-only' id='autocomplete-0-label'>
        Search
      </span>
    </div>
  )
}

export default React.memo(Search)
